import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { spacing } from '../../../theme/index';
import { Label } from './label';
import { Input } from './input';
export const DateWrapper = ({ children, className, ...rest }) => {
    return (<Container className={className} {...rest}>
      {children}
    </Container>);
};
const Container = styled.form `
  > div:not(:last-child) {
    margin-right: ${spacing.space16};
  }

  input {
    text-align: center;
  }
`;
export const DateField = ({ children, className, ...rest }) => {
    return (<DateInput className={className} {...rest}>
      {children}
    </DateInput>);
};
const DateInput = styled.div `
  display: inline-flex;
  flex-flow: column wrap;
`;
export const Day = forwardRef(({ onChange, id, nextId, className, ...rest }, ref) => {
    const handleChange = (e) => {
        if (!!onChange)
            onChange(e);
        if (e.length >= 2) {
            if (!!nextId) {
                // @ts-ignore-next
                document.querySelector(`input[id='${nextId}']`).focus();
            }
            return;
        }
    };
    return (<DayInput className={className}>
      <Label width={70}>Dato</Label>
      <Input ref={ref} name="day" id={id} onChange={(e) => handleChange(e)} placeholder="dd" width={70} pattern="[1-9]|[0-2][0-9]|[3][01]" maxLength={2} {...rest}/>
    </DayInput>);
});
const DayInput = styled.div ``;
export const Month = forwardRef(({ onChange, id, nextId, className, ...rest }, ref) => {
    const handleChange = (e) => {
        if (!!onChange)
            onChange(e);
        if (e.length >= 2) {
            if (!!nextId) {
                // @ts-ignore-next
                document.querySelector(`input[id='${nextId}']`).focus();
            }
            return;
        }
    };
    return (<MonthInput className={className}>
      <Label width={70}>Måned</Label>
      <Input ref={ref} id={id} name="month" onChange={(e) => handleChange(e)} placeholder="mm" width={70} pattern="[1-9]|[0][0-9]|[1][0-2]" maxLength="2" {...rest}/>
    </MonthInput>);
});
const MonthInput = styled.div ``;
export const Year = forwardRef(({ onChange, id, nextId, className, ...rest }, ref) => {
    const handleChange = (e) => {
        if (!!onChange)
            onChange(e);
        if (e.length >= 4) {
            if (!!nextId) {
                // @ts-ignore-next
                document.querySelector(`input[id='${nextId}']`).focus();
            }
            return;
        }
    };
    return (<YearInput className={className}>
      <Label width={100}>År</Label>
      <Input ref={ref} name="year" id={id} onChange={(e) => handleChange(e)} placeholder="åååå" width={100} pattern="[12][0-9]{3}" maxLength="4" {...rest}/>
    </YearInput>);
});
const YearInput = styled.div ``;
